import React from 'react';

const FieldActivityContext = React.createContext({
    fieldActivityId: null,
    setFieldActivityId: () => {}
});

export default FieldActivityContext;